window.okeReviewsWidgetOnInit = function () {
    setupAggregateHeader();

    // Widget lifecycle hook. Gets fired when Okendo Widgets are finished initializing
    const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewMain) {
        const callback = function (mutationList) {
            for (const mutation of mutationList) {
                mutation.addedNodes.forEach(n => setupIndividualReview(n));
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(reviewMain, { childList: true });
        // Run callback for the first time
        const reviews = document.querySelectorAll('.okeReviews-reviews-review');
        reviews.forEach(n => setupIndividualReview(n));
    }
};

function setupAggregateHeader() {
    const aggregateRating = document.querySelector('.okeReviews-reviewsAggregate-summary-rating');
    const reviewsControl = document.querySelector('.okeReviews-reviewsWidget-header-controls');
    const ratingSummary = document.querySelector('.okeReviews-reviewsAggregate-summary-rating-value');
    // Insert Aggregate Rating into header
    const reviewsCount = document.querySelector('.okeReviews-reviews-controls-reviewCount');
    if (aggregateRating && reviewsCount && ratingSummary) {
        aggregateRating.insertAdjacentElement('beforeend', reviewsCount);
        reviewsControl.insertAdjacentElement('afterbegin', aggregateRating);
        reviewsCount.insertAdjacentElement('beforebegin', ratingSummary);
        ratingSummary.append(" | ");
    }
}

function setupIndividualReview(nodeElement) {
    if (nodeElement) {
        // move review date above review helpful vote
        const reviewDate = nodeElement.querySelector('.okeReviews-review-date');
        const reviewHelpfulVote = nodeElement.querySelector('.js-okeReviews-reviewHelpful');
        if (reviewDate) {
            reviewHelpfulVote.insertAdjacentElement('beforebegin', reviewDate)
        }
    }
}